<template>
    <div @mouseover="enter" @mouseleave="leave" id="head">
        <a :href="link" target="_blank" @click="leave">
            <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45.5 45.5">
                <title>Etsy</title>
                <circle id="PermanentEtsyRing" cx="22.75" cy="22.75" r="22"/>
                <circle id="EtsyRing" cx="22.75" cy="22.75" r="22"/>
                <path id="EtsyLogo" d="M21.9,19.7c-.3,2-1.3,2.8-2.4,2.9v.6h1.4v5.1A1.94,1.94,0,0,0,23,30.4a2.22,2.22,0,0,0,2.2-1.3l-.3-.5a1.67,1.67,0,0,1-1.3.7c-.7,0-1.1-.5-1.1-1.8V23l2.4.2.1-1.1-2.5.1V19.6l-.6.1Zm5,7.9h-.6a8.84,8.84,0,0,1,0,2.3,7.19,7.19,0,0,0,2.4.5c1.7,0,3-.8,3-2.5,0-2.8-4-2.4-4-4.3,0-.8.7-1.1,1.4-1.1s1.1.2,1.2.5l.4,1.3h.6a14.92,14.92,0,0,1,.2-2.1,7.8,7.8,0,0,0-2.2-.4c-1.6,0-2.8.7-2.8,2.3,0,2.8,3.9,2.2,3.9,4.3,0,.7-.4,1.2-1.4,1.2a1.4,1.4,0,0,1-1.5-1l-.6-1ZM33.4,33c-.5,0-.6-.2-.7-.6l-.2-1.3h-.7a15.72,15.72,0,0,1-.4,2.3,2.86,2.86,0,0,0,1.7.5c1.1,0,2.7-.3,4.2-4l2.5-6.3c.2-.5.3-.6.9-.8l.3-.1v-.6l-1.5.1-1.6-.1v.6l.4.1q.6.15.6.6a.9.9,0,0,1-.1.5c-.2.5-1.3,3.4-1.9,4.7-.7-1.8-1.7-4.6-1.8-5v-.3q0-.45.6-.6l.5-.1V22l-2.2.2-1.7-.1v.6l.3.1c.4.2.4.2.7.9,1.1,2.6,2.3,5.9,2.7,7-.9,1.8-1.9,2.3-2.6,2.3Zm-21-13.7c0-.2,0-.3.3-.3h3.6c.6,0,1,.6,1.2,1.6l.2.9h.6c.1-2.4.2-3.5.2-3.5s-1.6.2-2.5.2H11.5L9,18.1v.7l.8.2c.6.1.7.3.8.8v8.8c0,.5-.2.7-.8.8l-.8.2v.7l2.5-.1h4.2c.9,0,3.1.1,3.1.1,0-.6.4-3.3.4-3.6h-.6L18,28.2a1.82,1.82,0,0,1-2,1.3H13.6c-.8,0-1.2-.3-1.2-1.1V24.6a22,22,0,0,1,2.3.1c.4,0,.7.2.9.8l.2.9h.7V24.2l.1-2.2h-.7l-.2,1c-.1.6-.2.8-.9.8s-2.4.1-2.4.1V19.3Z" transform="translate(-2.25 -2.25)"/>
            </svg>
        </a>
    </div>
</template>

<script>
// work on background transitions to make the hover less stark
// --> https://stackoverflow.com/questions/20012240/using-css-to-transition-the-fill-property-of-an-svg-path-on-hover
export default {
    props: {
        link: String,
        darkMode: Boolean
    },
    methods: {
        enter: function () {
            // document.getElementById("EtsyRing").style.stroke = "#D0D0D0";
            // document.getElementById("EtsyRing").style.fill = "#F1641E";

            // document.getElementById("EtsyLogo").style.fill = "#FFFFFF";
        },
        leave: function () {
            // document.getElementById("EtsyRing").style.stroke = this.darkMode ? "#000000" : "#FFFFFF";
            // document.getElementById("EtsyRing").style.fill = "none";

            // document.getElementById("EtsyLogo").style.fill = this.darkMode ? "#000000" : "#FFFFFF";
        }
    },
    mounted() {
        // set light mode attributes, icon dark by default
        if (!this.darkMode) {
            document.getElementById("PermanentEtsyRing").style.stroke = "#FFFFFF";
            document.getElementById("EtsyLogo").style.fill = "#FFFFFF";
        }
    }
}
</script>

<style scoped>
#head {
    height: 45px;
    width: 45px;
    /* margin-right: 10px; */
    /* margin-bottom: 10px; */
}
#PermanentEtsyRing {
    fill: none;
    stroke-width: 1.5px;
}
a > svg > #EtsyRing {
    fill: #F1641E;
    opacity: 0;
    transition: opacity .2s linear;
    stroke: none;
}
svg:hover > #EtsyRing {
    opacity: 1;
}
#EtsyLogo {
    fill-rule: evenodd;
}
svg {
    width: 45px;
    position: absolute;
}
</style>